export enum languageEnum {
  EN = 'en',
  SK = 'sk',
}
